import ImageWithFallback from '@/components/atoms/ImageWithFallback';

export function TeamHeader({ imageUrl, teamName }: { imageUrl: string; teamName: string }) {
	return (
		<div className="flex flex-col px-4 py-6 md:px-8">
			<div className="flex items-center gap-4">
				<div className="size-16 overflow-hidden rounded-lg border border-gray-200">
					<ImageWithFallback src={imageUrl} alt="Trade player" width={64} height={64} className="size-full object-cover" />
				</div>
				<p className="text-2xl font-semibold text-[#0A0A0A]">{teamName}</p>
			</div>
		</div>
	);
}
